import { FeatureStorage } from "@/_services/storage";

import BrowserHelper from "@/_helpers/browser/browser-helper";
import { mapGetters } from "vuex";
import SettingsService from "../_services/api/settings/graycorp/settings.service";
import { CommonStorage } from "../_services/storage";
let browserHelper = new BrowserHelper();

export default {
  props: { title: String, isXSmall: Boolean, isLarge: Boolean },
  data() {
    return {
      isLeaving: true,
      baseView: { page: "", mode: "", id: "", tab: "", query: "" },
      selectedViewType: undefined,
      isTablet: false,
      ignoreRouteChangeConfirmation: false,
      key: 0,
      selectedIndex: 0,
      routeError: false,
      formsConfig: {
        serverItems: [],
        editableOption: true,
        createOption: true,
        reviewOption: true,
        popupAlertVisible: false,
        popupAlertMessage: "",
      },
      serverValidationSummaryVisible: false,
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler: "handleRouteChange",
    },
    isXSmall: {
      // eslint-disable-next-line no-unused-vars
      handler: function (value) {
        // do something based on the screen size
      },
    },
  },
  computed: {
    ...mapGetters({ ignoreRouteChange: "ui/getIgnoreRouteChange" }),
    pageKey() {
      return this.baseView.mode + this.key;
    },
    getRefreshKey() {
      return new Date().getTime();
    },
  },
  async created() {
    this.$store.dispatch("dataContext/setAdvanceFilterApplied", false);
    this.isTablet = this.baseView.query.t
      ? true
      : browserHelper.tablet
        ? true
        : false;
  },
  async beforeRouteLeave(to, from, next) {
    if (this.baseView.mode == "create" || this.baseView.mode == "edit") {
      if (this.ignoreRouteChangeConfirmation || this.ignoreRouteChange) {
        this.ignoreRouteChangeConfirmation = false;
        this.$store.dispatch("ui/setIgnoreRouteChange", false);
        next();
      } else {
        let confirmLeaving = await this.$confirm(
          "You have unsaved changes. Are you sure you want to leave?",
          "Unsaved changes"
        );

        if (confirmLeaving) {
          this.isLeaving = true;
          this.$store.dispatch("dataContext/setDataViewType", undefined);
          next();
        } else {
          this.isLeaving = false;
          // next(false);
          return false;
        }
      }
    } else next();
  },
  methods: {
    resetLabels() {
      this.$store.dispatch("transactionTemplate/setPrimaryLabel", null);
      this.$store.dispatch("transactionTemplate/setSecondaryLabel", null);
      this.$store.dispatch("transactionTemplate/setTertiaryLabel", null);
    },
    // eslint-disable-next-line no-unused-vars
    handleRouteChange(to, from) {
      // eslint-disable-next-line no-console
      // this.$logger.debug(to, from);
      this.$logger.debug("loaded ", this.baseView.mode);
      this.$logger.info("This message is from new Logger");
      this.baseView.view = "";
      this.baseView.mode = "";
      this.baseView.id = "";
      this.baseView.tab = "";
      this.baseView.query = "";
      var urlTokens = to.path.split("/");
      // var urlTokens = this.$router.currentRoute.path.split("/");
      this.$logger.debug("UrlTokens", urlTokens);

      this.baseView.query = to.query;

      if (urlTokens.length > 1) {
        this.baseView.view = urlTokens[1];
      }

      // this.$logger.trackEventOpenScreen(this.baseView.view);

      // this pattern only has => base/Page/:id
      if (urlTokens.length == 2) {
        this.baseView.mode = "review";
      } else if (urlTokens.length == 3 && urlTokens[2] != "create") {
        if (urlTokens[2] == "review" || urlTokens[2] == "edit") {
          this.baseView.mode = urlTokens[2];
        } else {
          this.baseView.id = urlTokens[2];
          this.baseView.mode = "review";
        }
      } else {
        if (urlTokens.length > 2) {
          if (urlTokens[1] == "report") {
            this.baseView.mode = "review";
          } else {
            this.baseView.mode = urlTokens[2].toLowerCase();
          }
        }
        if (urlTokens.length > 3) {
          this.baseView.id = urlTokens[3];
        }
        if (urlTokens.length > 4) {
          this.baseView.tab = urlTokens[4].toLowerCase();
        }
      }
      if (this.baseView.mode) {
        if (
          FeatureStorage.checkPermission(
            to.meta.applicationFeatureCode,
            this.baseView.mode
          ) == false
        ) {
          // eslint-disable-next-line no-console
          // this.$logger.debug("redirect to Unauthorized from baseview!");
          this.setIgnoreRouteChangeConfirmation();
          this.$router.push({
            name: "unauthorized",
          });
        }
      }

      this.formsConfig.editableOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "edit"
      );

      this.formsConfig.createOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "create"
      );

      this.formsConfig.reviewOption = FeatureStorage.checkPermission(
        to.meta.applicationFeatureCode,
        "review"
      );
    },
    refreshView() {
      this.key += 1;
      // this.baseView.query = this.$router.currentRoute.query;
    },
    setIgnoreRouteChangeConfirmation() {
      this.ignoreRouteChangeConfirmation = true;
      this.$store.dispatch("ui/setIgnoreRouteChange", true);
    },

    onRowClicked(e, rowSelectOptions) {
      let property = rowSelectOptions.idProperty;
      let id = e.data[property];
      this.$router
        .push({
          path: `/${rowSelectOptions.page}/${rowSelectOptions.mode}/${id}`,
          query: rowSelectOptions.query ? rowSelectOptions.query : null,
        })
        .then((res) => {
          if (res)
            setTimeout(() => {
              this.$store.dispatch("ui/setViewRouted", true);

              if (rowSelectOptions.rowSelectCallBack)
                rowSelectOptions.rowSelectCallBack();
            }, 50);
        })
        .catch((err) => {
          if (err) this.routeError = true;
        });
    },
    // showLoading(show) {
    //   this.formsConfig.loadingVisible = show;
    // },

    displayServerError(error, genericMessage) {
      this.$logger.debug("error", error);

      this.formsConfig.serverItems = [];

      if (
        error.status === 400 &&
        error.data &&
        error.data.Errors &&
        typeof error.data.Errors === "object" &&
        !Array.isArray(error.data.Errors) &&
        error.data.Errors !== null
      ) {
        // catering for Server Validation Errors display
        const errorsArray = [];
        var data = error.data;
        for (const key in data.Errors) {
          if (data.Errors.hasOwnProperty(key)) {
            // check if this is an array data.Errors[key]
            if (Array.isArray(data.Errors[key])) {
              errorsArray.push(...data.Errors[key]);
            } else {
              errorsArray.push(data.Errors[key]);
            }
          }
        }
        this.formsConfig.serverItems.push(...errorsArray);
      } else if (error.message || error.Message) {
        this.formsConfig.serverItems.push(error.message || error.Message);
      } else if (error.data && (error.data.message || error.data.Message)) {
        this.formsConfig.serverItems.push(error.data.message || error.data.Message);
      } else if (error.data && (error.data.detail || error.data.Detail)) {
        this.formsConfig.serverItems.push(
          error.data.detail || error.data.Detail
        );
      } else if (error.data.value && error.data.value.length > 0) {
        this.formsConfig.serverItems.push(
          JSON.parse(error.data.value)[0].ErrorMessage
        );
      } else if (error.data && error.data.length > 0) {
        this.formsConfig.serverItems.push(error.data[0].ErrorMessage);
      } else if (error.data && error.data.errors) {
        // eslint-disable-next-line no-unused-vars
        for (const [key, value] of Object.entries(error.data.errors)) {
          this.formsConfig.serverItems.push(value[0]);
        }
        this.formsConfig.serverItems.push(error.data.errors[0]);
      } else if (error.data && error.data.ValidationResult && error.data.ValidationResult.length > 0) {
        error.data.ValidationResult.forEach(element => {
          this.formsConfig.serverItems.push(element.ErrorMessage);
        });
      } else if (!error.data || error.data === "") {
        this.$notify(genericMessage || `Server error (${error.status || error.statusText || "unknown"})`, "error");
      } else if (error.data && error.data.error && error.data.error.innererror) {
        this.formsConfig.serverItems.push(error.data.error.innererror.message);
      } else if (error.data && error.data.error && error.data.error.message) {
        var item = undefined;
        if (JSON.parse(error.data.error.message)[0].MemberNames.length > 0) {
          var memberNames = JSON.parse(error.data.error.message)[0].MemberNames;
          if (memberNames[0])
            item =
              memberNames[0] +
              " " +
              JSON.parse(error.data.error.message)[0].ErrorMessage;
        }

        if (!item) item = JSON.parse(error.data.error.message)[0].ErrorMessage;

        this.formsConfig.serverItems.push(item);
      } else {
        this.$notify(genericMessage, "error");
      }

      this.formsConfig.serverValidationSummaryVisible = true;
    },
    displayAlert(message) {
      this.formsConfig.popupAlertMessage = message;
      this.formsConfig.popupAlertVisible = true;
    },
    displayGenericAlert(message) {
      this.$alert(message, "Error");
    },
    async setScreenNavigation(key) {
      await SettingsService.getBySettingName(key).then((res) => {
        if (res.data.value.length > 0) {
          CommonStorage.saveItems(key, res.data.value[0].SettingValue);
        }
      });
    },
    getScreenNavigation(key, url) {
      var version = CommonStorage.getItems(key);
      if (version == "V1") {
        return `/${url}/create`;
      } else {
        return `/${url}-${version.toLowerCase()}/create`;
      }
    },
    getScreenRowClickNavigation(key, url) {
      var version = CommonStorage.getItems(key);
      if (version == "V1") {
        return url;
      } else {
        return `${url}-${version.toLowerCase()}`;
      }
    },
  },
};
